<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Shift Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: this.$route.params.shift,
    };
  },
  computed: {
    ...mapGetters("staffModule", ["Shift", "StaffSaveStatus"]),
    ...mapGetters("auth", ["user_permissions"]),
  },
  methods: {
    ...mapActions({
      FetchStaffShift: "staffModule/fetchShift",
    }),
  },
  updated() {
    // setTimeout(() => {
    //   window.print();
    // }, 1000);
  },
  created() {
    this.FetchStaffShift(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end" v-if="user_permissions.print_shift_report">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Shift</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white p-2">
          <div class="print-font" style="padding-left: 15px">
            <table width="100%" class="mt-3">
              <b-spinner
                v-if="!Shift"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <tr v-else>
                <td width="50%">
                  <img
                    :src="Shift.clinicLogo ? Shift.clinicLogo : '--'"
                    alt="Logo"
                    height="100"
                  />
                </td>
                <td width="50%" style="text-align: right; padding-right: 15px !important">
                  <strong style="font-size: calc(1.2671875rem + 0.20625vw)">
                    {{ Shift.clinicName ? Shift.clinicName : "---" }}</strong
                  >
                  <p>
                    <span> {{ Shift.clinicAddress ? Shift.clinicAddress : "---" }}</span>
                    <br />
                    <strong>Tel: </strong
                    >{{ Shift.clinicPhone ? "+256" + Shift.clinicPhone : "---" }}
                    <br />
                    <strong>Email: </strong
                    >{{ Shift.clinicEmail ? Shift.clinicEmail : "---" }}
                  </p>
                </td>
              </tr>
            </table>
            <hr style="border-style: dashed; width: 97%" />
            <h5
              style="
                text-align: center;
                font-weight: bold;
                font-family: Courier New, Courier, Lucida Sans Typewriter,
                  Lucida Typewriter, monospace;
              "
            >
              <p>
                <span
                  ><strong>
                    <u>{{ Shift.staffName }} Shift Report</u></strong
                  ></span
                >
                <br />
                {{ Shift.start }}
                To {{ Shift.end }}
                <br />
                Created on {{ Shift.time }}
              </p>
            </h5>

            <h5><strong>Comments</strong></h5>
            <p
              v-html="Shift.comment ? Shift.comment : '---'"
              style="font-size: 17px; background-color: #fff"
            ></p>
            <center>
              <table width="100%" class="table" style="font-size: 15px">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Patient</th>
                    <th>Service</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in Shift.records" :key="r">
                    <td>{{ r + 1 }}</td>
                    <td>{{ record.patient }}</td>
                    <td>{{ record.service }}</td>
                    <td>{{ record.time }}</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
